/* ============================================================================
   HN PDP — upsell in pagina prodotto: le due superfici (tools/hn-pdp.md)
   ----------------------------------------------------------------------------
   A  «Molti clienti aggiungono anche»  sotto il bottone (blocco hn_pdp_cross)
   B  il pacchetto sotto la descrizione  (sezione hn-pdp-pack), in due modi:
        1) «Lo trovi anche nel Set da N»: il contenitore AL POSTO del singolo;
        2) «Completa la routine»: il prodotto più i compagni, solo se insieme
           superano la soglia della spedizione gratuita.

   Questo file DISEGNA e MISURA. Non classifica: il ranking, le esclusioni, la
   soglia e la risalita ai contenitori sono del motore del carrello
   (assets/hn-cart.js, `HNCart.reco`), che li fa sul carrello «virtuale» =
   carrello vero + il prodotto che si sta guardando. Un secondo scorer qui
   sarebbe la seconda copia da tenere allineata a mano, e divergerebbe dal
   drawer al primo cambio di catalogo. Nessun numero di policy vive qui: pesi,
   quote di esplorazione e tetto del salto di prezzo stanno in `w.pdp` del
   catalogo; i testi nelle impostazioni dei due blocchi.

   Le regole che contano, e perché:
   - il PRIMO disegno è sincrono e senza rete (fotografia del carrello del
     motore): la riga sta sotto il bottone d'acquisto, un salto lì si vede;
   - un prezzo non verificato non si mostra: al suo posto un segnaposto finché
     /products/<handle>.js non conferma (una richiesta per prodotto per
     sessione, la stessa cache del drawer). Se la rete fallisce vale il catalogo;
   - le proposte NON cambiano mentre il cliente le guarda: dopo un'aggiunta la
     riga resta lì con «Aggiunto ✓» invece di essere sostituita sotto il dito.
     Si riclassifica solo cambiando variante;
   - l'impressione si conta quando il blocco entra nel viewport, non al
     disegno: B sta sotto la descrizione e al caricamento non l'ha visto
     nessuno. «Visto» e «non visto» devono restare distinguibili nel dato;
   - il gruppo di controllo (impostazione di tema `hn_pdp_holdout`) è deciso
     PRIMA, dallo script in snippets/hn-pdp.liquid: qui si registra soltanto.

   Misura: dataLayer `hn_view_item_list` / `hn_select_item` / `hn_add_to_cart`
   con le liste `hn-pdp-cross`/`hn_pdp_cross` e `hn-pdp-pack`/`hn_pdp_pack`, e
   l'attributo carrello `hn_pdp` (separato da `hn_reco`, che resta del drawer).
   Formato dell'attributo, versione 1:
     1;v:<w.pdp.v>|h:<0|1>|n:<ancore viste>|i:<s><ancora>:<pid>.<n per slot>.<fonte>,…
       |a:<s><ancora>:<pid>@<fonte>.<slot>,…
   dove <s> è la superficie (a = sotto il bottone, b = pacchetto) e <ancora> è
   l'indice nella lista n. Tetto 500 caratteri: si scartano le impressioni più
   vecchie, mai le aggiunte prima delle impressioni.

   Diagnostica: ?hnpdpdebug=1.
   ============================================================================ */
(function () {
  'use strict';
  if (window.__HN_PDP_LOADED__) return;   // lo snippet è reso due volte (A e B)
  window.__HN_PDP_LOADED__ = true;

  var DEBUG = false;
  try { DEBUG = /[?&]hnpdpdebug=1/.test(window.location.search || ''); } catch (e) {}
  var DESIGN = !!(window.Shopify && window.Shopify.designMode);
  /* ?hnpdp=on (deciso dallo script dello snippet): blocchi visibili anche nel
     gruppo di controllo, per guardarli. Una visita forzata non si misura: non
     direbbe niente su come si comportano i clienti, e sporcherebbe il gruppo. */
  var FORCED = !!window.__hnPdpForce;

  /* Liste GA4: una per superficie, altrimenti non si tarano separatamente.
     ⚠️ `item_list_name` resta scritto per esteso qui: tools/hn-ga4-doppioni.mjs
     legge da questo file i nomi delle liste nostre, e una costante costruita
     non la troverebbe. */
  var LISTS = {
    cross: { item_list_id: 'hn-pdp-cross', item_list_name: 'hn_pdp_cross', s: 'a' },
    pack: { item_list_id: 'hn-pdp-pack', item_list_name: 'hn_pdp_pack', s: 'b' }
  };
  /* Fonte in un carattere. Le chiavi in comune con il drawer DEVONO avere lo
     stesso codice di `SRC_CODE` in assets/hn-cart.js (test PD20): chi legge i
     due attributi insieme li confronta. `upgrade` e `anchor` sono solo di qui. */
  var SRC_CODE = { affinity: 'a', margin: 'm', explore: 'e', related: 'r', crosssell: 'c',
                   complement: 'x', legacy: 'l', pin: 'p', upgrade: 'u', anchor: 'q' };
  var FALLBACK_SRC = { related: 1, crosssell: 1, margin: 1, complement: 1, explore: 1, legacy: 1 };

  function srcOf(p) { return (p && p.__hnSrc) || 'legacy'; }
  function code(src) { return SRC_CODE[src] || String(src || '?').charAt(0); }
  function reco() { return window.HNCart && window.HNCart.reco; }
  function cartState() { return (window.HNCart && window.HNCart.state) || {}; }

  /* ------------------------------- utilità ------------------------------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  /* Testi del merchant: tutto escapato, poi si riammette SOLO il grassetto. Un
     testo d'impostazione non deve poter iniettare markup nella pagina. */
  function rich(tpl, vars) {
    return esc(tpl).replace(/&lt;(\/?)b&gt;/g, '<$1b>').replace(/\{(\w+)\}/g, function (m, k) {
      return vars && vars[k] != null ? esc(vars[k]) : '';
    });
  }
  function plain(tpl, vars) {
    return String(tpl || '').replace(/<\/?b>/g, '').replace(/\{(\w+)\}/g, function (m, k) {
      return vars && vars[k] != null ? vars[k] : '';
    });
  }
  function fnv(str) {
    var x = 0x811c9dc5;
    for (var i = 0; i < str.length; i++) { x ^= str.charCodeAt(i); x = Math.imul(x, 16777619) >>> 0; }
    return x >>> 0;
  }
  // finalizzatore: i bit bassi di un FNV puro dipendono dai bit bassi dei caratteri
  function mix(h) {
    h ^= h >>> 16; h = Math.imul(h, 0x85ebca6b); h ^= h >>> 13; h = Math.imul(h, 0xc2b2ae35); h ^= h >>> 16;
    return h >>> 0;
  }
  function uid() {
    try {
      var u = window.localStorage.getItem('hn_ab_uid') || '';
      if (/^[0-9a-f]{16}$/.test(u)) return u;
    } catch (e) {}
    var c = document.cookie.match(/(?:^|; )hn_ab_uid=([0-9a-f]{16})/);
    return c ? c[1] : '';
  }
  // seme stabile per visitatore e prodotto: cambiare variante o carrello non
  // rimescola la proposta, e la stessa persona rivede la stessa cosa
  function seedFor(anchor) { var u = uid(); return u ? u + '|' + anchor.id : ''; }
  function readJSON(el, attr) { try { return JSON.parse(el.getAttribute(attr) || 'null'); } catch (e) { return null; } }
  function money(c) { var R = reco(); return R ? R.money(c) : (c / 100).toFixed(2); }
  function sized(img, w) {
    if (!img) return '';
    if (img.indexOf('//') === 0) img = 'https:' + img;
    return img.replace(/(\.[a-z]+)(\?|$)/i, '_' + w + 'x$1$2');
  }
  function productUrl(handle) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'products/' + handle;
  }
  function priceOf(p) { return p.price != null ? p.price : (p.price_min || 0); }
  /* Prezzo INIZIALE: il barrato quando è davvero più alto, altrimenti il prezzo.
     Regola del merchant (2026-10-01): ogni risparmio si calcola dai prezzi
     iniziali dei singoli, non da quelli già scontati. */
  function initialOf(p) { var pr = priceOf(p), cp = p.compare_at_price || 0; return cp > pr ? cp : pr; }
  function catalog() { return (window.HN_CART_DATA && window.HN_CART_DATA.p) || {}; }
  /* La spunta e' disegnata col TRATTO: `stroke` sta nello stile del path, perche'
     base.css mette `stroke: currentColor` su ogni svg e un attributo di
     presentazione perde contro qualunque regola CSS. Il colore lo da' la classe. */
  var CHECK = '<svg class="hn-pdp__ck" width="13" height="13" viewBox="0 0 16 16" aria-hidden="true">' +
    '<path d="M3 8.6 6.2 12 13 4.6" style="fill:none;stroke:currentColor;stroke-width:2.3;stroke-linecap:round;stroke-linejoin:round"/></svg>';

  /* Varianti di un candidato: il bottone è SEMPRE «Aggiungi» (scelta del
     merchant, 2026-10-01: niente «Scegli» che porta via dalla pagina). Se
     un'essenza coincide con il nome del prodotto che si sta guardando (il
     deodorante Selva del Sud sulla pagina del sapone Selva del Sud) vince quella;
     altrimenti si prende la PRIMA variante disponibile, nell'ordine dell'admin.
     ⛔ Il blocco NON la scrive (merchant, 2026-10-02: «scelta variante solo nel
     popup, non metterla nel testo del blocco»): si sceglie nell'anteprima, che
     parte preselezionata proprio su questa. `variantLabel` serve all'anteprima. */
  function variantLabel(t) {
    t = String(t || '');
    if (!t || t === 'Default Title' || /^(combinazione|variante)\s*\d+$/i.test(t)) return '';
    return t.replace(/^[a-z]\)\s*/i, '');
  }
  function chooseVariant(p, anchorName) {
    var vs = (p.variants || []).filter(function (v) { return v.available !== false; });
    if (!vs.length) return null;
    if (vs.length === 1) return { id: vs[0].id, label: variantLabel(vs[0].title) };
    var name = String(anchorName || '').toLowerCase();
    for (var i = 0; i < vs.length; i++) {
      if (name && String(vs[i].title || '').toLowerCase() === name) return { id: vs[i].id, label: variantLabel(vs[i].title), match: true };
    }
    return { id: vs[0].id, label: variantLabel(vs[0].title), first: true };
  }

  /* ----------------------------- variante ancora ----------------------------- */
  function formInput(anchor) {
    var f = document.getElementById('product-form-' + anchor.id);
    var i = f && f.querySelector('[name="id"]');
    return i || document.querySelector('form[action*="/cart/add"] [name="id"]');
  }
  function currentVariant(anchor) {
    var vs = anchor.vs || [], inp = formInput(anchor), want = inp ? parseInt(inp.value, 10) : anchor.v;
    var v = null;
    vs.forEach(function (x) { if (x.id === want) v = x; });
    if (!v) vs.forEach(function (x) { if (x.id === anchor.v) v = x; });
    return v || vs[0] || null;
  }
  /* Il tema commuta le varianti con jQuery e non emette eventi propri: la verità
     osservabile è il suo bottone (stesso criterio di assets/hn-delivery.js). */
  function atcButton(anchor) {
    var f = document.getElementById('product-form-' + anchor.id);
    return (f && f.querySelector('[data-btn-addtocart], #product-add-to-cart')) ||
      document.querySelector('[data-btn-addtocart], #product-add-to-cart');
  }
  function anchorSoldOut(anchor, v) {
    if (v && v.a === false) return true;
    var b = atcButton(anchor);
    if (!b) return false;
    return !!b.disabled || b.classList.contains('is-soldout') || b.classList.contains('is-notify-me');
  }
  function realCart() { var R = reco(); return (R && (R.cart || R.cartSnapshot())) || { items: [] }; }
  function inRealCart(pid) {
    return (realCart().items || []).some(function (i) { return String(i.product_id) === String(pid); });
  }
  function realSubtotal() {
    // stesso criterio del motore: i regali (riga a 0 con _hn_gift) non contano
    return (realCart().items || []).reduce(function (s, i) {
      var pr = i.properties || {};
      return s + ((pr._hn_gift === 'true' || pr._hn_gift === true) ? 0 : (i.final_line_price || 0));
    }, 0);
  }

  /* ---------------------------------- log ---------------------------------- */
  var LOG_KEY = 'hn_pdp';
  function loadLog() {
    var l = null;
    try { l = JSON.parse(window.sessionStorage.getItem(LOG_KEY) || 'null'); } catch (e) {}
    if (!l || typeof l !== 'object') l = {};
    // `i` (pid -> 1) e `a[].p` sono letti anche dal motore (seenFromPdpLog)
    l.i = l.i || {}; l.q = l.q || []; l.a = l.a || []; l.n = l.n || []; l.h = l.h ? 1 : 0;
    return l;
  }
  function saveLog(l) { try { window.sessionStorage.setItem(LOG_KEY, JSON.stringify(l)); } catch (e) {} }
  function attrValue(l) {
    var R = reco(), mv = (R && R.pdpMapVersion && R.pdpMapVersion()) || 'v0';
    var q = l.q.slice(), a = l.a.slice(), n = l.n.slice();
    function build() {
      var anc = [];
      function idx(x) { var k = anc.indexOf(x); if (k < 0) { anc.push(x); k = anc.length - 1; } return k; }
      n.forEach(idx);
      var imp = q.map(function (r) { return r.s + idx(r.n) + ':' + r.p + '.' + r.k.join('-') + '.' + r.c; });
      var add = a.map(function (r) { return r.s + idx(r.n) + ':' + r.p + '@' + r.c + '.' + r.k; });
      return '1;v:' + mv + '|h:' + l.h + '|n:' + anc.join(',') +
        (imp.length ? '|i:' + imp.join(',') : '') + (add.length ? '|a:' + add.join(',') : '');
    }
    var v = build();
    while (v.length > 500 && (q.length || n.length > 1 || a.length)) {
      if (q.length) q.shift(); else if (n.length > 1) n.shift(); else a.shift();
      v = build();
    }
    return v;
  }
  /* L'attributo si scrive SOLO quando il carrello ha qualcosa: per misurare non
     si crea un carrello a chi rimbalza. Il valore si consegna SEMPRE al motore,
     che col carrello vuoto lo tiene in attesa e lo scrive alla prima aggiunta su
     QUALUNQUE pagina: questo file gira solo sulle pagine prodotto, e chi aggiunge
     dalla griglia non ci torna (difetto del 2026-10-01, test PD46). */
  function flush() {
    if (DESIGN || FORCED) return;
    var R = reco(); if (!R || !R.setAttribute) return;
    R.setAttribute('hn_pdp', attrValue(loadLog()));
  }
  function noteAnchor(anchorId, h) {
    if (FORCED) return;
    var l = loadLog(), k = String(anchorId);
    l.h = h ? 1 : 0;
    if (l.n.indexOf(k) < 0) l.n.push(k);
    while (l.n.length > 20) l.n.shift();
    saveLog(l); flush();
  }
  /* Memoria delle pagine prodotto aperte, FRA le visite (localStorage `hn_pv`,
     id -> istante, le ultime 20): la legge l'offerta al clic su «Procedi
     all'ordine» (assets/hn-cart.js, coViewed), per cui un prodotto guardato e
     non preso e' il candidato piu' probabile. Non e' misura: si scrive anche in
     visita forzata e nel gruppo di controllo, perche' dice cosa interessa al
     cliente, non cosa gli abbiamo mostrato. Niente dati personali. */
  function notePageView(anchorId) {
    try {
      var pv = JSON.parse(window.localStorage.getItem('hn_pv') || 'null');
      if (!pv || typeof pv !== 'object') pv = {};
      pv[String(anchorId)] = Date.now();
      Object.keys(pv).sort(function (a, b) { return pv[b] - pv[a]; }).slice(20)
        .forEach(function (k) { delete pv[k]; });
      window.localStorage.setItem('hn_pv', JSON.stringify(pv));
    } catch (e) {}
  }
  function noteImpressions(s, anchorId, products) {
    if (FORCED) return;
    var l = loadLog();
    products.forEach(function (p, slot) {
      var pid = String(p.id), key = s + '|' + anchorId + '|' + pid, cur = null;
      for (var i = 0; i < l.q.length; i++) if (l.q[i].key === key) { cur = l.q[i]; break; }
      if (!cur) { cur = { key: key, s: s, n: String(anchorId), p: pid, k: [], c: '' }; l.q.push(cur); }
      while (cur.k.length <= slot) cur.k.push(0);
      cur.k[slot]++;
      cur.c = code(srcOf(p));
      l.i[pid] = 1;
    });
    while (l.q.length > 40) l.q.shift();
    saveLog(l); flush();
  }
  function noteAdd(s, anchorId, pid, src, slot) {
    if (FORCED) return;
    var l = loadLog();
    l.a.push({ p: String(pid), s: s, n: String(anchorId), c: code(src), k: slot || 0 });
    while (l.a.length > 16) l.a.shift();
    saveLog(l); flush();
  }

  /* ------------------------------- dataLayer ------------------------------- */
  function dlOn() {
    if (DESIGN || FORCED) return false;
    var c = window.HNCart && window.HNCart.config;
    return !!(c && c.analytics && c.analytics.dataLayer);
  }
  function row(p, i, list, priceCents) {
    return { item_id: String(p.id), item_name: p.title, price: (priceCents != null ? priceCents : priceOf(p)) / 100,
             index: i, item_list_id: list.item_list_id, item_list_name: list.item_list_name,
             hn_source: srcOf(p) };
  }
  function pushView(M, products, extra) {
    if (!dlOn() || !products.length) return;
    var R = reco(), righe = products.map(function (p, i) { return row(p, i, M.list); });
    window.dataLayer = window.dataLayer || [];
    // ⚠️ `ecommerce: null` prima: senza, GTM fonde l'oggetto con quello precedente
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(Object.assign({
      event: 'hn_view_item_list',
      item_list_id: M.list.item_list_id, item_list_name: M.list.item_list_name,
      hn_map: R.pdpMapVersion(), hn_anchor: String(M.anchor.id), hn_surface: M.list.s,
      ecommerce: { item_list_id: M.list.item_list_id, item_list_name: M.list.item_list_name, items: righe }
    }, extra || {}));
  }
  function pushSelect(M, p, i) {
    if (!dlOn()) return;
    var art = row(p, i, M.list);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'hn_select_item', hn_anchor: String(M.anchor.id), hn_surface: M.list.s,
      ecommerce: { item_list_id: M.list.item_list_id, item_list_name: M.list.item_list_name, items: [art] }
    });
  }
  function addMeta(M, p, i, priceCents, src) {
    var R = reco();
    return { item_list_id: M.list.item_list_id, item_list_name: M.list.item_list_name,
             index: i, product_id: p.id, price: (priceCents != null ? priceCents : priceOf(p)) / 100,
             hn_source: src || srcOf(p), hn_map: R.pdpMapVersion(),
             hn_anchor: String(M.anchor.id), hn_surface: M.list.s };
  }

  /* Impressione quando il blocco è visto davvero (metà della sua altezza, o metà
     dello schermo se è più alto dello schermo). Senza IntersectionObserver si
     conta al disegno: meglio un'impressione in più che un blocco cieco. */
  function whenSeen(M, key, fn) {
    if (M.unwatch) { M.unwatch(); M.unwatch = null; }
    if (M.seenKey === key) return;          // stesso stato già contato
    var fire = function () { if (M.seenKey === key) return; M.seenKey = key; fn(); };
    if (!('IntersectionObserver' in window)) { fire(); return; }
    var done = false;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (done || !en.isIntersecting) return;
        var h = en.intersectionRect ? en.intersectionRect.height : 0;
        if (en.intersectionRatio >= 0.5 || h >= window.innerHeight * 0.5) { done = true; io.disconnect(); fire(); }
      });
    }, { threshold: [0, 0.25, 0.5, 0.75, 1] });
    io.observe(M.el);
    M.unwatch = function () { done = true; io.disconnect(); };
  }

  function show(M, on) { M.el.style.display = on ? '' : 'none'; }
  function dbg(M, lines) {
    if (!DEBUG) return;
    var n = M.el.querySelector('.hn-pdp__dbg') || document.createElement('pre');
    n.className = 'hn-pdp__dbg';
    n.textContent = lines.join('\n');
    if (!n.parentNode) M.el.appendChild(n);
    M.el.style.display = '';
  }

  /* ======================= A · sotto il bottone ======================= */
  /* Verificato = stock E combinazioni lette da Shopify in questa sessione (2026-10-05):
     prima bastava lo stock del prodotto, e una combinazione esaurita passava. */
  function verified(p) {
    var R = reco();
    if (R && R.checked) return R.checked(p.id);
    var st = cartState().stock || {}; return st[p.id] !== undefined;
  }

  /* La riga «spedizione/omaggio» è SPENTA di default (testi vuoti, merchant
     2026-10-01): il traguardo è calcolato sul carrello + il prodotto della
     pagina, quindi la frase presuppone che il cliente aggiunga anche quello.
     Il pacchetto (B) lo dice esplicitamente, qui no. Con un testo scritto
     nell'editor torna, e deve dire lui la condizione. */
  function crossLine(M, p, ctx) {
    var goal = ctx && ctx.goal, pr = priceOf(p);
    if (goal && pr >= goal.gapCents) {
      // fuori dall'Italia (anche con una VPN) la spedizione gratuita dai 49 non vale
      var txt = goal.type === 'shipping' ? (M.cfg.it === false ? '' : M.cfg.ship) : (goal.type === 'gift' ? M.cfg.gift : '');
      if (txt) return '<p class="hn-pdp-cross__meta is-ship">' + CHECK + '<span>' + esc(txt) + '</span></p>';
    }
    return '<p class="hn-pdp-cross__meta">' + esc(p.subtitle || '') + '</p>';
  }
  function crossPrice(M, p, act) {
    var pr = priceOf(p), cp = p.compare_at_price || 0;
    if (!(verified(p) || M.verifyDone)) return '<p class="hn-pdp-cross__price"><span class="hn-pdp-cross__wait" aria-label="prezzo in aggiornamento"></span></p>';
    return '<p class="hn-pdp-cross__price"><span class="hn-pdp-cross__now">' + esc(money(pr)) + '</span>' +
      (cp > pr ? '<s class="hn-pdp-cross__was">' + esc(money(cp)) + '</s>' : '') + '</p>';
  }
  function crossRow(M, p, i, ctx) {
    var act = M.acts[p.id], url = productUrl(p.handle), img = sized(p.featured_image, 160);   // 72px su desktop, a 2x
    var done = inRealCart(p.id), R = reco();
    /* Il link alla scheda resta solo per un candidato senza varianti disponibili,
       che il motore di norma ha già escluso come esaurito. */
    var btn = act
      ? '<button type="button" class="hn-pdp-cross__add' + (done ? ' is-done' : '') + '" data-hn-pdp-add="' + p.id + '"' +
          (done ? ' disabled' : '') + '>' + esc(done ? R.t('added') : R.t('add')) + '</button>'
      : '<a class="hn-pdp-cross__add" href="' + esc(url) + '" data-hn-pdp-sel="' + p.id + '">' + esc(M.cfg.choose || 'Scegli') + '</a>';
    return '<div class="hn-pdp-cross__row" data-id="' + p.id + '">' +
      '<a class="hn-pdp-cross__img" href="' + esc(url) + '" data-hn-pdp-sel="' + p.id + '" tabindex="-1" aria-hidden="true">' +
        (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="52" height="52">' : '') + '</a>' +
      '<div class="hn-pdp-cross__main">' +
        '<a class="hn-pdp-cross__name" href="' + esc(url) + '" data-hn-pdp-sel="' + p.id + '">' + esc(p.short_title || p.title) + '</a>' +
        crossLine(M, p, ctx) + crossPrice(M, p, act) +
      '</div>' + btn + '</div>';
  }

  function rankCross(M) {
    var R = reco(), v = M.variant;
    return R.forProduct({ productId: M.anchor.id, variantId: v.id, price: v.p, handle: M.anchor.h,
                          limit: M.cfg.limit || 2, seed: seedFor(M.anchor) });
  }
  /* Le proposte restano le stesse, i loro numeri no: dopo la verifica il motore
     ha corretto il prezzo (hydrate legge le correzioni), e la riga deve dire
     quello, non il valore del catalogo con cui era stata classificata. */
  function freshPrices(ps) {
    var R = reco();
    ps.forEach(function (p) {
      var h = R.hydrate(p.id); if (!h) return;
      p.price = h.price; p.price_min = h.price; p.compare_at_price = h.compare_at_price;
    });
  }
  function paintCross(M) {
    var R = reco(), r = M.rank, ps = M.shown;
    if (!ps.length) { M.el.innerHTML = ''; show(M, false); return; }
    freshPrices(ps);
    var anchorName = (R.hydrate(M.anchor.id) || {}).short_title || '';
    M.acts = {};
    ps.forEach(function (p) { M.acts[p.id] = chooseVariant(p, anchorName); });
    var fallbackOnly = ps.every(function (p) { return FALLBACK_SRC[srcOf(p)]; });
    var head = fallbackOnly ? (M.cfg.heading_alt || M.cfg.heading) : M.cfg.heading;
    M.el.innerHTML = '<p class="hn-pdp-cross__head">' + esc(head || '') + '</p>' +
      ps.map(function (p, i) { return crossRow(M, p, i, r.ctx); }).join('');
    show(M, true);
    M.el.querySelectorAll('[data-hn-pdp-add]').forEach(function (b) {
      var id = parseInt(b.getAttribute('data-hn-pdp-add'), 10), i = indexOf(ps, id), p = ps[i], act = M.acts[id];
      b.addEventListener('click', function () {
        if (b.disabled || b.classList.contains('is-done') || !act) return;
        M.touched = true;
        R.add(act.id, 1, null, b, function () {
          b.classList.add('is-done'); b.disabled = true;
          noteAdd('a', M.anchor.id, p.id, srcOf(p), i);
        }, addMeta(M, p, i));
      });
    });
    wireSelect(M, ps);
    if (DEBUG) debugCross(M);
  }
  /* Foto e nome di una proposta: il clic apre l'ANTEPRIMA invece di portare via
     dalla pagina (sotto, «Anteprima del prodotto»). Il link resta vero: con un
     tasto modificatore, col tasto centrale o senza JavaScript si va alla scheda.
     Il dato completo si chiede appena il puntatore o il dito si posano, così
     l'anteprima di norma si apre già piena. */
  function wireSelect(M, ps) {
    M.el.querySelectorAll('[data-hn-pdp-sel]').forEach(function (a) {
      var id = parseInt(a.getAttribute('data-hn-pdp-sel'), 10), i = indexOf(ps, id);
      if (i < 0) return;
      var pre = function () { var R = reco(); if (M.cfg.qv !== false && R && R.product) R.product(ps[i].handle); };
      a.addEventListener('pointerenter', pre);
      a.addEventListener('touchstart', pre, { passive: true });
      a.addEventListener('click', function (e) {
        pushSelect(M, ps[i], i);
        if (M.cfg.qv === false || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();
        openQV(M, ps[i], i, a);
      });
    });
  }
  function indexOf(ps, id) { for (var i = 0; i < ps.length; i++) if (ps[i].id === id) return i; return -1; }

  /* Il carrello e' «noto» se il motore l'ha gia' letto o se c'e' la sua
     fotografia di sessione. Altrimenti il primo disegno classifica su un carrello
     vuoto per ipotesi — e appena arriva quello vero la proposta va rifatta, se il
     cliente non ci ha ancora messo mano: tenerla «stabile» vorrebbe dire
     mostrare come appena aggiunto qualcosa che era nel carrello da prima. */
  function cartKnown() { var R = reco(); return !!(R && (R.cart || R.cartSnapshot())); }
  function renderCross(M, fresh) {
    var R = reco();
    if (!fresh && M.shown && !M.cartKnown && !M.touched) fresh = true;
    if (fresh || !M.shown) {
      M.cartKnown = cartKnown();
      M.rank = rankCross(M);
      M.shown = (M.rank && M.rank.products) || [];
    } else {
      // stessa proposta, contesto aggiornato (soglia, carrello): niente salti
      var r2 = rankCross(M); M.rank = { products: M.shown, ctx: r2.ctx, excluded: r2.excluded };
    }
    paintCross(M);
    var ps = M.shown;
    if (!ps.length) return;
    var key = M.variant.id + '|' + ps.map(function (p) { return p.id; }).join(',');
    whenSeen(M, key, function () {
      noteImpressions('a', M.anchor.id, ps);
      pushView(M, ps);
    });
    // verifica DOPO il disegno (mai prima): stock e prezzo dalla scheda vera
    var daVerificare = ps.filter(function (p) { return !verified(p); });
    if (!daVerificare.length) return;
    R.verify(daVerificare).then(function (res) {
      M.verifyDone = true;
      if (res && res.sold && res.sold.length) { renderCross(M, true); return; }
      paintCross(M);
    }, function () { M.verifyDone = true; paintCross(M); });
  }

  function debugCross(M) {
    var r = M.rank || {}, ctx = r.ctx || {}, goal = ctx.goal;
    var lines = ['hn-pdp A · ancora ' + M.anchor.id + ' variante ' + M.variant.id + ' (' + money(M.variant.p) + ')',
      'controllo: ' + (window.__hnPdpH ? 'SI' : 'no') + ' (quota ' + (window.__hnPdpPct || 0) + '%)  seme: ' + (seedFor(M.anchor) || '(token carrello)'),
      'carrello virtuale: ' + money(ctx.virtualSubtotal || 0) + '  traguardo: ' + (goal ? goal.type + ' tra ' + money(goal.gapCents) : 'nessuno'),
      'mappa: ' + reco().pdpMapVersion()];
    (M.shown || []).forEach(function (p, i) {
      var sc = p.__hnScore || {};
      lines.push('slot ' + i + ': ' + (p.short_title || p.title) + ' · ' + srcOf(p) + ' · base ' +
        (sc.base != null ? sc.base.toFixed(3) : '?') + ' full ' + (sc.full != null ? sc.full.toFixed(3) : '?') +
        ' · bisogni ' + ((reco().needs && reco().needs(p.id)) || []).join('+') +
        (!M.acts[p.id] ? ' · nessuna variante disponibile' : M.acts[p.id].first ? ' · prima variante ' + M.acts[p.id].id : ''));
    });
    var ex = r.excluded || {}, k = Object.keys(ex);
    if (k.length) lines.push('esclusi: ' + k.map(function (id) { return id + '=' + ex[id]; }).join(' '));
    dbg(M, lines);
  }

  /* ===================== B · il pacchetto sotto la descrizione ===================== */
  function contentsOf(e, variantId) {
    var sc = e.sc || [], comp = e.comp || [];
    (e.vs || []).forEach(function (v) {
      if (String(v.id) === String(variantId)) { sc = v.sc || sc; comp = v.comp || comp; }
    });
    return { sc: sc.slice(), comp: comp.slice() };
  }
  /* Modo 1: il contenitore. Il risparmio si CALCOLA dai prezzi veri dei pezzi
     che contiene — mai dal prezzo barrato del set, che è un numero scritto a
     mano (quello del Set da 5 non coincide con la somma dei suoi saponi).
     I pezzi contano al loro prezzo INIZIALE (il barrato del singolo, se c'è).
     Set di soli saponi: prezzo al pezzo e somma degli N singoli. Kit misto:
     solo la somma dei componenti — il prezzo al pezzo di un kit con uno shampoo
     dentro sarebbe più alto di un sapone singolo, cioè una bugia involontaria. */
  function containers(M) {
    var R = reco(), D = catalog(), W = R.weights(), st = cartState();
    var stock = st.stock || {}, failed = st.upsellFailed || {};
    var tetto = (W.upgradeMaxMult || 0) * M.variant.p;
    /* `w.pdp.never` vale anche qui: il Kit Viso sta nel catalogo per l'offerta al checkout,
       non per questa pagina (2026-10-28) */
    var never = (W.never || []).map(String);
    var out = [];
    (R.containersOf(M.anchor.id, M.variant.id) || []).forEach(function (c) {
      if (never.indexOf(String(c.id)) >= 0) return;
      if (inRealCart(c.id) || stock[c.id] === false || failed[c.id]) return;
      var hp = R.hydrate(c.id), e = D[c.id];
      if (!hp || !hp.available || !e) return;
      var price = priceOf(hp);
      if (!(tetto > 0) || price > tetto) return;
      var parts = contentsOf(e, c.variantId);
      /* Un set a scelta con un sapone ESAURITO non parte con lo SKU standard ma col predefinito
         che lo salta (motore: HNCart.bys, vale per ogni strada): i pezzi che si mostrano sono
         quelli che arrivano davvero, non lo Scirocco che non c'e'. Se in quel predefinito manca
         il prodotto della pagina il «prendilo nel set» non e' piu' vero, e non si propone. */
      var by = window.HNCart && window.HNCart.bys, pz = by && by.enabled() ? by.plan(c.id, c.variantId) : null;
      if (pz) {
        parts = { sc: by.soaps.reduce(function (acc, s) { for (var n = pz.sel[s.id] || 0; n > 0; n--) acc.push(Number(s.id)); return acc; }, []), comp: parts.comp };
        if (parts.sc.indexOf(Number(M.anchor.id)) < 0) return;
      }
      var ids = parts.sc.concat(parts.comp), sum = 0, ok = true;
      ids.forEach(function (id) { var q = R.hydrate(id); if (!q) ok = false; else sum += initialOf(q); });
      if (!ok || !(sum - price > 0)) return;
      var homog = !parts.comp.length && parts.sc.every(function (id) { return (D[id] || {}).cat === 'soap'; });
      out.push({ id: c.id, variantId: c.variantId, p: hp, price: price, ids: ids, sum: sum,
                 save: sum - price, unit: homog ? Math.round(price / parts.sc.length) : 0 });
    });
    out.sort(function (a, b) { return a.price - b.price || a.id - b.id; });
    return out;
  }
  /* Prodotti che il blocco A mostra in questa pagina: il pacchetto ne propone
     altri. Chi scende fin sotto la descrizione è già passato da quei due e non li
     ha presi; ripeterli toglierebbe due proposte nuove (scelta del 2026-10-01,
     delegata dal merchant: «nel modo che secondo te porta più soldi»). */
  function crossShownIds() {
    var out = [];
    MOUNTS.forEach(function (X) {
      if (X.surface === 'cross' && !X.holdout) (X.shown || []).forEach(function (p) { out.push(String(p.id)); });
    });
    return out;
  }
  function planPack(M) {
    var R = reco(), W = R.weights();
    /* Modo 1, «Risparmia prendendo il Kit»: se il prodotto sta dentro un set o kit
       conveniente si propone quello, al posto del singolo (merchant, 2026-10-01).
       Altrimenti il gruppo. Interruttore `m1_on` della sezione, acceso. */
    if (M.cfg.m1_on && !inRealCart(M.anchor.id)) {
      var el = containers(M);
      if (el.length) {
        /* Default: il salto più piccolo. Esplorazione (fase 1): una parte delle
           visite vede uno dei salti più grandi, scelto a caso fra quelli sotto il
           tetto — è il dato che dice quale salto il cliente accetta, e nessun
           ragionamento da poltrona lo dirà (tools/hn-pdp.md §6). */
        var pick = el[0], src = 'upgrade', pct = DESIGN ? 0 : (W.explorePct || 0);
        if (el.length > 1 && pct > 0) {
          var s = seedFor(M.anchor) || String(M.anchor.id);
          if ((mix(fnv(s + '|pack')) % 100) < Math.round(pct * 100)) {
            pick = el[1 + (mix(fnv(s + '|pack-x')) % (el.length - 1))]; src = 'explore';
          }
        }
        return { mode: 1, pick: pick, src: src, eligible: el };
      }
    }
    /* Modo 2, il gruppo: SEMPRE, su ogni pagina prodotto (anche set e kit), con
       al massimo `limit` compagni — il ranking è quello del motore. Tutti
       spuntati in partenza: è il pacchetto intero quello che porta lo scontrino
       più alto, e chi non vuole qualcosa toglie la spunta.
       Cosa NON ripetere di A lo decide il motore (`avoid`): prima bisogni che A
       non ha proposto, poi prodotti nuovi, e solo in ultimo un prodotto di A —
       meglio un doppione che un gruppo monco. Il seed ha un suffisso proprio,
       così esplorazione e scambio di posizione di B non coincidono con quelli
       di A nella stessa visita. */
    var lim = M.cfg.limit || 2, giaInA = crossShownIds(), seed = seedFor(M.anchor);
    var r = R.forProduct({ productId: M.anchor.id, variantId: M.variant.id, price: M.variant.p,
                           handle: M.anchor.h, limit: lim, avoid: giaInA, seed: seed ? seed + '|b' : '' });
    var ctx = r.ctx, anchorName = (R.hydrate(M.anchor.id) || {}).short_title || '';
    var comps = [];
    (r.products || []).forEach(function (p) {
      var act = chooseVariant(p, anchorName);
      if (!act) return;                                // null solo senza varianti disponibili
      p.__act = act;
      comps.push(p);
    });
    if (!comps.length) return { mode: 0, why: 'nessun compagno', ctx: ctx };
    var sel = {};
    comps.forEach(function (p) { sel[p.id] = true; });
    return { mode: 2, comps: comps, sel: sel, ctx: ctx, goals: (R.goals && R.goals()) || [] };
  }

  function tileHTML(M, id, mine) {
    var R = reco(), q = R.hydrate(id) || {};
    return '<li class="hn-pdp-pack__tile' + (mine ? ' is-mine' : '') + '">' +
      '<span class="hn-pdp-pack__timg">' +
        (q.featured_image ? '<img src="' + esc(sized(q.featured_image, 320)) + '" alt="" loading="lazy">' : '') +
        (mine && M.cfg.m1_pill ? '<span class="hn-pdp-pack__pill">' + esc(M.cfg.m1_pill) + '</span>' : '') +
      '</span><p class="hn-pdp-pack__tname">' + esc(q.short_title || q.title || '') + '</p></li>';
  }
  function paintMode1(M, plan) {
    var R = reco(), c = plan.pick, cfg = M.cfg, anchorName = (R.hydrate(M.anchor.id) || {}).short_title || '';
    var ids = [M.anchor.id].concat(c.ids.filter(function (id) { return String(id) !== String(M.anchor.id); }));
    var tiles, cols;
    if (ids.length <= 4) {
      tiles = ids.map(function (id, i) { return tileHTML(M, id, i === 0); }).join('');
      cols = ids.length;
    } else {
      var resto = ids.length - 3;
      tiles = ids.slice(0, 3).map(function (id, i) { return tileHTML(M, id, i === 0); }).join('') +
        '<li class="hn-pdp-pack__tile"><span class="hn-pdp-pack__more">+' + resto + '</span>' +
        '<p class="hn-pdp-pack__tname">' + esc(plain(cfg.m1_more, { n: resto })) + '</p></li>';
      cols = 4;
    }
    var name = c.p.short_title || c.p.title, done = inRealCart(c.id);
    var vars = { container: name, anchor: anchorName, unit: money(c.unit), sum: money(c.sum), save: money(c.save) };
    M.el.innerHTML = '<div class="hn-pdp-pack__body">' +
      (cfg.m1_eyebrow ? '<p class="hn-pdp-pack__eyebrow">' + rich(cfg.m1_eyebrow, vars) + '</p>' : '') +
      '<h3 class="hn-pdp-pack__head">' + rich(cfg.m1_heading, vars) + '</h3>' +
      (cfg.m1_sub ? '<p class="hn-pdp-pack__sub">' + rich(cfg.m1_sub, vars) + '</p>' : '') +
      '<div class="hn-pdp-pack__m1">' +
        '<ul class="hn-pdp-pack__strip' + (cols === 4 ? ' hn-pdp-pack__strip--4' : cols === 2 ? ' hn-pdp-pack__strip--2' : '') + '">' + tiles + '</ul>' +
        '<div class="hn-pdp-pack__buy">' +
          '<p class="hn-pdp-pack__price"><span class="hn-pdp-pack__now">' + esc(money(c.price)) + '</span>' +
            (c.unit && cfg.m1_unit ? '<span class="hn-pdp-pack__unit">' + rich(cfg.m1_unit, vars) + '</span>' : '') +
            (cfg.m1_ref ? '<span class="hn-pdp-pack__ref">' + rich(cfg.m1_ref, vars) + '</span>' : '') + '</p>' +
          '<button type="button" class="hn-pdp-pack__cta' + (done ? ' is-done' : '') + '" data-hn-pdp-buy' + (done ? ' disabled' : '') + '>' +
            esc(done ? R.t('added') : plain(cfg.m1_cta, vars)) + '</button>' +
        '</div>' +
      '</div></div>';
    show(M, true);
    var b = M.el.querySelector('[data-hn-pdp-buy]'), p = c.p;
    p.__hnSrc = plan.src;
    b.addEventListener('click', function () {
      if (b.disabled) return;
      M.touched = true;
      R.add(c.variantId, 1, null, b, function () {
        b.classList.add('is-done'); b.disabled = true;
        noteAdd('b', M.anchor.id, c.id, plan.src, 0);
      }, addMeta(M, p, 0, c.price, plan.src), function () {
        /* Rifiutata da Shopify (combinazione esaurita da poco): il motore la ricorda
           e qui si rifà la proposta senza di lei, invece di lasciare un bottone che
           «non fa nulla» (merchant, 2026-10-05). */
        M.plan = planPack(M); renderPack(M, false);
      });
    });
  }

  function packRowHTML(M, p, opts) {
    var url = productUrl(p.handle), img = sized(p.featured_image, 160), pr = opts.price, cp = opts.compare || 0;
    var box = '<span class="hn-pdp-pack__box" role="checkbox" tabindex="' + (opts.fixed ? '-1' : '0') + '"' +
      ' aria-checked="' + (opts.checked ? 'true' : 'false') + '"' + (opts.fixed ? ' aria-disabled="true"' : '') +
      ' aria-label="' + esc(p.short_title || p.title) + '">' + CHECK + '</span>';
    /* Il prodotto della pagina (riga senza id) non è un link: portava alla pagina
       stessa, cioè la ricaricava. Le proposte sì, e il clic apre l'anteprima. */
    var tag = opts.id != null ? 'a' : 'span';
    var href = opts.id != null ? ' href="' + esc(url) + '" data-hn-pdp-sel="' + opts.id + '"' : '';
    return '<div class="hn-pdp-pack__row' + (opts.fixed ? ' is-fixed' : '') + (opts.inCart ? ' is-in' : '') + '"' +
      (opts.id != null ? ' data-hn-pdp-row="' + opts.id + '"' : '') + '>' + box +
      '<' + tag + ' class="hn-pdp-pack__rimg"' + href + ' tabindex="-1" aria-hidden="true">' +
        (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="44" height="44">' : '') + '</' + tag + '>' +
      '<span class="hn-pdp-pack__rmain"><' + tag + ' class="hn-pdp-pack__rname"' + href + '>' +
        esc(p.short_title || p.title) + '</' + tag + '>' +
        (opts.sub ? '<span class="hn-pdp-pack__rsub" style="display:block">' + esc(opts.sub) + '</span>' : '') +
        '<span class="hn-pdp-pack__rmeta" style="display:block">' + esc(opts.meta || '') + '</span></span>' +
      '<span class="hn-pdp-pack__rprice">' + esc(money(pr)) + (cp > pr ? '<s>' + esc(money(cp)) + '</s>' : '') + '</span></div>';
  }
  function paintMode2(M, plan) {
    var R = reco(), cfg = M.cfg, ah = R.hydrate(M.anchor.id) || {}, anchorName = ah.short_title || '';
    var anchorIn = inRealCart(M.anchor.id);
    var vars = { anchor: anchorName };
    var html = '<div class="hn-pdp-pack__body">' +
      (cfg.m2_eyebrow ? '<p class="hn-pdp-pack__eyebrow">' + rich(cfg.m2_eyebrow, vars) + '</p>' : '') +
      '<h3 class="hn-pdp-pack__head">' + rich(cfg.m2_heading, vars) + '</h3>' +
      (cfg.m2_sub ? '<p class="hn-pdp-pack__sub">' + rich(cfg.m2_sub, vars) + '</p>' : '') +
      '<div class="hn-pdp-pack__rows">' +
      packRowHTML(M, { title: ah.title, short_title: anchorName, handle: M.anchor.h, featured_image: ah.featured_image },
        { fixed: true, checked: true, inCart: anchorIn, price: M.variant.p, compare: M.variant.c || 0, meta: anchorIn ? cfg.m2_incart : cfg.m2_this }) +
      /* Il sottotitolo è lo stesso del blocco A (`subtitle` del catalogo, una
         copia sola per le due superfici): dice a cosa serve il prodotto, che è
         ciò che manca a chi lo vede per la prima volta in un gruppo. Non sul
         prodotto della pagina: lì il cliente sa già cos'è, e «Questo articolo»
         è l'informazione che conta. La variante NON si scrive (si sceglie
         nell'anteprima, vedi chooseVariant). Interruttore `m2_subs` (assente
         nell'HTML in cache = acceso). */
      plan.comps.map(function (p) {
        var inC = inRealCart(p.id);
        return packRowHTML(M, p, { id: p.id, fixed: inC, inCart: inC, checked: inC || !!plan.sel[p.id],
          sub: cfg.m2_subs !== false ? (p.subtitle || '') : '',
          price: priceOf(p), compare: p.compare_at_price, meta: inC ? cfg.m2_incart : '' });
      }).join('') +
      '</div>' +
      '<div class="hn-pdp-pack__tot"><span class="hn-pdp-pack__totl">' + esc(cfg.m2_total || '') + '</span>' +
        '<span class="hn-pdp-pack__totv"><s class="hn-pdp-pack__totw" data-hn-pdp-was hidden></s>' +
        '<span class="hn-pdp-pack__totn" data-hn-pdp-tot></span></span></div>' +
      '<p class="hn-pdp-pack__bene" data-hn-pdp-bene hidden>' + CHECK + '<span data-hn-pdp-bene-t></span></p>' +
      '<button type="button" class="hn-pdp-pack__cta" data-hn-pdp-buy></button></div>';
    M.el.innerHTML = html;
    show(M, true);
    M.el.querySelectorAll('[data-hn-pdp-row]').forEach(function (r) {
      var id = parseInt(r.getAttribute('data-hn-pdp-row'), 10), box = r.querySelector('.hn-pdp-pack__box');
      function toggle(ev) {
        if (ev && ev.target && ev.target.closest && ev.target.closest('a')) return;   // i link portano alla scheda
        if (box.getAttribute('aria-disabled') === 'true' || M.packDone) return;
        M.touched = true;
        plan.sel[id] = !plan.sel[id];
        box.setAttribute('aria-checked', plan.sel[id] ? 'true' : 'false');
        updatePack(M, plan);
      }
      r.addEventListener('click', toggle);
      box.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); toggle(null); } });
    });
    var btn = M.el.querySelector('[data-hn-pdp-buy]');
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      M.touched = true;
      var add = toAdd(M, plan);
      if (!add.length) return;
      var items = add.map(function (x) { return { id: x.vid, quantity: 1, properties: x.props || undefined }; });
      var metas = add.map(function (x) { return addMeta(M, x.p, x.slot, x.price, x.src); });
      R.addMany(items, metas, btn, function () {
        M.packDone = true; btn.classList.add('is-done'); btn.disabled = true;
        add.forEach(function (x) { noteAdd('b', M.anchor.id, x.p.id, x.src, x.slot); });
      });
    });
    wireSelect(M, plan.comps);
    updatePack(M, plan);
  }
  function toAdd(M, plan) {
    var out = [];
    if (!inRealCart(M.anchor.id)) {
      var vc = M.variant.c || 0;
      /* Il set della pagina coi saponi scelti dal cliente (assets/hn-bys.js): la
         scelta viaggia con lui, altrimenti il gruppo aggiungerebbe la selezione
         consigliata al posto di quella appena fatta. */
      var bys = window.HNBys && window.HNBys.props ? window.HNBys.props(M.anchor.id) : null;
      out.push({ vid: M.variant.id, p: { id: M.anchor.id, title: (reco().hydrate(M.anchor.id) || {}).title },
                 price: M.variant.p, was: vc > M.variant.p ? vc : M.variant.p, src: 'anchor', slot: 0, props: bys });
    }
    plan.comps.forEach(function (p, i) {
      if (plan.sel[p.id] && !inRealCart(p.id)) out.push({ vid: p.__act.id, p: p, price: priceOf(p), was: initialOf(p), src: srcOf(p), slot: i });
    });
    return out;
  }
  function updatePack(M, plan) {
    var R = reco(), add = toAdd(M, plan), tot = 0, was = 0;
    add.forEach(function (x) { tot += x.price; was += x.was || x.price; });
    var cartSub = realSubtotal();
    var tn = M.el.querySelector('[data-hn-pdp-tot]'); if (tn) tn.textContent = money(tot);
    /* Totale barrato = somma dei prezzi iniziali di ciò che si aggiunge: c'è solo
       se qualche pezzo è davvero scontato, non si inventa. */
    var tw = M.el.querySelector('[data-hn-pdp-was]');
    if (tw) { tw.textContent = was > tot ? money(was) : ''; tw.hidden = !(was > tot); }
    /* La riga verde nomina solo i traguardi che il GRUPPO fa superare: carrello
       sotto la soglia, carrello + gruppo sopra. Qui la condizione è dichiarata,
       perché il prodotto della pagina è una riga del gruppo. Un traguardo già
       raggiunto non si annuncia. */
    var bene = M.el.querySelector('[data-hn-pdp-bene]');
    if (bene) {
      var detti = {}, frasi = [];
      (plan.goals || []).forEach(function (g) {
        if (!(cartSub < g.cents && cartSub + tot >= g.cents) || detti[g.type]) return;
        /* La soglia dei 49 vale solo per le spedizioni in Italia (UE 9,90 €,
           resto del mondo 19,90 €, sempre): fuori la riga non la promette.
           L'omaggio invece lo aggiunge il carrello ovunque. */
        var txt = g.type === 'shipping' ? (M.cfg.it === false ? '' : M.cfg.m2_benefit) : (g.type === 'gift' ? M.cfg.m2_benefit_gift : '');
        if (txt) { detti[g.type] = 1; frasi.push(rich(txt, { threshold: money(g.cents) })); }
      });
      var t = bene.querySelector('[data-hn-pdp-bene-t]');
      if (t) t.innerHTML = frasi.join(' · ');
      bene.hidden = !frasi.length;
    }
    var btn = M.el.querySelector('[data-hn-pdp-buy]');
    if (!btn || M.packDone) return;
    btn.disabled = !add.length;
    btn.textContent = add.length > 1 ? plain(M.cfg.m2_cta_many, { n: add.length }) : plain(M.cfg.m2_cta_one, {});
  }

  function renderPack(M, fresh) {
    var R = reco();
    if (fresh || !M.plan) { M.cartKnown = cartKnown(); M.plan = planPack(M); M.packDone = false; }
    var plan = M.plan;
    if (plan.mode === 0) { M.el.innerHTML = ''; show(M, false); if (DEBUG) debugPack(M); return; }
    var ps = plan.mode === 1 ? [plan.pick.p] : plan.comps;
    if (plan.mode === 1) plan.pick.p.__hnSrc = plan.src;
    // B sta sotto la piega: si disegna solo a prezzi verificati, niente segnaposto
    var daVerificare = ps.filter(function (p) { return !verified(p); });
    var paint = function () {
      if (plan.mode === 1) paintMode1(M, plan); else paintMode2(M, plan);
      if (DEBUG) debugPack(M);
      var key = M.variant.id + '|' + plan.mode + '|' + ps.map(function (p) { return p.id; }).join(',');
      whenSeen(M, key, function () {
        noteImpressions('b', M.anchor.id, ps);
        pushView(M, ps, { hn_pack_mode: plan.mode });
      });
    };
    if (!daVerificare.length || M.packVerified) { paint(); return; }
    R.verify(daVerificare).then(function (res) {
      M.packVerified = true;
      if (res && res.sold && res.sold.length) { renderPack(M, true); return; }
      // anche una combinazione esaurita: la variante scelta va rifatta (il Kit Starter, 2026-10-05)
      if (res && ((res.priced && res.priced.length) || (res.vsold && res.vsold.length))) { M.plan = planPack(M); renderPack(M, false); return; }
      paint();
    }, function () { M.packVerified = true; paint(); });
  }
  function refreshPack(M) {
    // carrello cambiato: stessa proposta, stati aggiornati (vedi cartKnown)
    var plan = M.plan;
    if (!plan || plan.mode === 0 || (!M.cartKnown && !M.touched)) { renderPack(M, true); return; }
    if (plan.mode === 1) {
      var done = inRealCart(plan.pick.id), b = M.el.querySelector('[data-hn-pdp-buy]');
      if (b && done && !b.classList.contains('is-done')) { b.classList.add('is-done'); b.disabled = true; b.textContent = reco().t('added'); }
      return;
    }
    if (M.packDone) return;
    paintMode2(M, plan);
  }
  function debugPack(M) {
    var p = M.plan || {}, lines = ['hn-pdp B · ancora ' + M.anchor.id + ' variante ' + M.variant.id + ' (' + money(M.variant.p) + ')',
      'controllo: ' + (window.__hnPdpH ? 'SI' : 'no') + '  modo: ' + (p.mode || 0) + (p.why ? ' (' + p.why + ')' : '')];
    if (p.mode === 1) {
      lines.push('contenitori sotto il tetto (' + reco().weights().upgradeMaxMult + 'x):');
      p.eligible.forEach(function (c) {
        lines.push('  ' + (c === p.pick ? '> ' : '  ') + (c.p.short_title || c.id) + ' ' + money(c.price) + ' (x' +
          (c.price / M.variant.p).toFixed(1) + ') somma ' + money(c.sum) + ' risparmio ' + money(c.save) + (c === p.pick ? ' · ' + p.src : ''));
      });
    } else if (p.mode === 2) {
      lines.push('traguardi ' + (p.goals || []).map(function (g) { return g.type + ' ' + money(g.cents); }).join(', ') +
        '  carrello ' + money(realSubtotal()) + '  evitati perche\' gia\' in A: ' + (crossShownIds().join(',') || 'nessuno'));
      p.comps.forEach(function (c, i) { lines.push('  slot ' + i + ': ' + (c.short_title || c.title) + ' · ' + srcOf(c) +
        ' · bisogni ' + ((reco().needs && reco().needs(c.id)) || []).join('+') + (p.sel[c.id] ? ' · spuntato' : '')); });
    }
    dbg(M, lines);
  }

  /* ======================= Anteprima del prodotto ======================= */
  /* Dal 2026-10-02 (merchant: «se uno clicca sui prodotti non va alla pagina del
     prodotto ma apre un pop-up»). Chi guarda una proposta stava per comprare il
     prodotto della pagina: una pagina nuova è un'uscita dal funnel, e non è
     detto che torni. Qui vede foto, prezzo, descrizione, sceglie la variante e
     aggiunge, senza lasciare la pagina.
     - È l'UNICO posto in cui si sceglie la variante (merchant: «scelta variante
       solo nel popup»). Parte preselezionata su quella che il bottone del blocco
       aggiungerebbe (chooseVariant), così i due percorsi non divergono.
     - Un'anteprima nostra, NON il «quick view» del tema: accenderlo
       (`show_quick_view`) farebbe comparire i pulsanti di pagamento rapido, che
       l'hack di velocità rompe (CLAUDE.md, «Codice intenzionale» §4).
     - Il dato completo è /products/<handle>.js, la risposta che il motore
       scarica già per verificare il prezzo e tiene in memoria (`reco.product`).
       Finché non c'è, l'anteprima mostra il catalogo (nome, foto, prezzo
       verificato, varianti) e un segnaposto al posto della descrizione.
     - Si chiude con ×, tocco fuori, Esc, trascinando giù la maniglia (telefono)
       e col tasto INDIETRO: senza, «indietro» porterebbe via dalla pagina, cioè
       proprio l'uscita che l'anteprima serve a evitare.
     - Un'aggiunta da qui è un'aggiunta del blocco (stessa superficie, slot e
       fonte in `hn_pdp`); il dataLayer la marca con `hn_via: 'popup'`. */
  var QV = { root: null, card: null, open: false, pushed: false, ignorePop: false, y: 0, pad: '' };
  var QV_VARS = ['--hn-pdp-acc', '--hn-pdp-grey', '--hn-pdp-ph', '--hn-pdp-r'];
  var QV_X = '<svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">' +
    '<path d="M4 4l10 10M14 4 4 14" style="fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round"/></svg>';

  function chipLabel(x) { return String(x == null ? '' : x).replace(/^[a-z]\)\s*/i, ''); }
  function imgKey(u) {
    return String(u || '').split('?')[0].replace(/^https?:/, '').replace(/_\d*x\d*(\.[a-z]+)$/i, '$1');
  }
  /* Blocco dello scroll di fondo, sicuro su iOS (overflow:hidden da solo non
     basta su Safari). Su desktop si compensa la barra di scorrimento che
     sparisce, altrimenti la pagina sotto salta di lato all'apertura. */
  function qvLock() {
    var de = document.documentElement, b = document.body.style;
    QV.y = window.scrollY || window.pageYOffset || 0;
    var bar = window.innerWidth - de.clientWidth;
    QV.pad = b.paddingRight;
    de.style.overflow = 'hidden';
    b.position = 'fixed'; b.top = (-QV.y) + 'px'; b.left = '0'; b.right = '0'; b.width = '100%';
    if (bar > 0) b.paddingRight = bar + 'px';
  }
  function qvUnlock() {
    var b = document.body.style;
    document.documentElement.style.overflow = '';
    b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = ''; b.paddingRight = QV.pad || '';
    window.scrollTo(0, QV.y);
  }

  /* Il dato da mostrare, in una forma sola: il prodotto completo se è arrivato,
     altrimenti il catalogo (hydrate), che ha già nomi e disponibilità delle
     varianti. I prezzi del catalogo valgono finché non arriva la risposta vera. */
  function qvData() {
    var R = reco(), h = R.hydrate(QV.p.id) || QV.p, f = QV.full, src = f || h;
    var names = (src.options || []).map(function (o) { return typeof o === 'string' ? o : (o && o.name) || ''; });
    var vs = (src.variants || []).map(function (v) {
      var fi = v.featured_image, vals = (v.options && v.options.length) ? v.options.slice()
        : [v.option1, v.option2, v.option3].filter(function (x) { return x != null; });
      return { id: v.id, title: v.title, available: v.available !== false, vals: vals,
               price: f && v.price != null ? v.price : priceOf(h),
               compare: f ? (v.compare_at_price || 0) : (h.compare_at_price || 0),
               image: fi ? (typeof fi === 'string' ? fi : fi.src || '') : '' };
    });
    var imgs = ((f && f.images) || []).map(function (u) { return typeof u === 'string' ? u : (u && u.src) || ''; })
      .filter(Boolean);
    if (!imgs.length && h.featured_image) imgs = [h.featured_image];
    return { h: h, vs: vs, names: names, images: imgs, description: f ? (f.description || '') : null };
  }
  function qvCur(d) {
    var v = null;
    d.vs.forEach(function (x) { if (String(x.id) === String(QV.sel)) v = x; });
    if (!v || !v.available) { var a = d.vs.filter(function (x) { return x.available; })[0]; if (a) v = a; }
    v = v || d.vs[0] || null;
    if (v) QV.sel = v.id;
    return v;
  }
  function sameOthers(v, cur, k) {
    if (!cur) return true;
    for (var j = 0; j < v.vals.length; j++) if (j !== k && v.vals[j] !== cur.vals[j]) return false;
    return true;
  }
  function qvOptsHTML(d, cur) {
    if (d.vs.length < 2) return '';
    return d.names.map(function (name, k) {
      var vals = [];
      d.vs.forEach(function (v) { var x = v.vals[k]; if (x != null && vals.indexOf(x) < 0) vals.push(x); });
      if (vals.length < 2) return '';
      var curVal = cur ? cur.vals[k] : '';
      return '<div class="hn-pdp-qv__opt"><p class="hn-pdp-qv__optl">' + esc(name || 'Variante') + ': <b>' + esc(chipLabel(curVal)) + '</b></p>' +
        '<div class="hn-pdp-qv__chips" role="radiogroup" aria-label="' + esc(name || 'Variante') + '">' +
        vals.map(function (x) {
          var ok = d.vs.some(function (v) { return v.available && v.vals[k] === x && sameOthers(v, cur, k); });
          var on = x === curVal;
          return '<button type="button" class="hn-pdp-qv__chip' + (on ? ' is-on' : '') + (ok ? '' : ' is-out') + '" role="radio"' +
            ' aria-checked="' + (on ? 'true' : 'false') + '"' + (ok ? '' : ' aria-disabled="true"') +
            ' data-hn-qv-opt="' + k + '" data-hn-qv-val="' + esc(x) + '">' + esc(chipLabel(x)) + '</button>';
        }).join('') + '</div></div>';
    }).join('');
  }
  /* Set con più combinazioni («Combinazione 1/2»): il nome non dice niente, il
     contenuto sì. Viene dal catalogo (`vs[].sc`/`comp`), lo stesso dato con cui
     il motore evita le profumazioni doppie. */
  function qvHas(cur) {
    var e = catalog()[QV.p.id], R = reco();
    if (!cur || !e || !(e.vs || []).some(function (v) { return v.sc || v.comp; })) return '';
    var parts = contentsOf(e, cur.id), names = parts.sc.concat(parts.comp).map(function (id) {
      var q = R.hydrate(id); return q ? (q.short_title || q.title) : '';
    }).filter(Boolean);
    return names.length ? (QV.M.cfg.qv_has || 'Contiene:') + ' ' + names.join(', ') : '';
  }
  function qvPriceHTML(v) {
    if (!v) return '';
    return '<span class="hn-pdp-qv__now">' + esc(money(v.price)) + '</span>' +
      (v.compare > v.price ? '<s class="hn-pdp-qv__was">' + esc(money(v.compare)) + '</s>' : '');
  }
  function qvMediaHTML(d) {
    var imgs = d.images.length ? d.images : [''], alt = d.h.title || '';
    return '<div class="hn-pdp-qv__strip" data-hn-qv-strip>' + imgs.map(function (u, k) {
      return '<div class="hn-pdp-qv__slide">' + (u ? '<img src="' + esc(sized(u, 720)) + '" alt="' + (k ? '' : esc(alt)) + '"' +
        ' width="720" height="720"' + (k ? ' loading="lazy"' : '') + '>' : '') + '</div>';
    }).join('') + '</div>' +
    (imgs.length > 1 ? '<div class="hn-pdp-qv__dots">' + imgs.map(function (u, k) {
      return '<button type="button" class="hn-pdp-qv__dot' + (k ? '' : ' is-on') + '" data-hn-qv-dot="' + k + '"' +
        ' aria-label="Foto ' + (k + 1) + ' di ' + imgs.length + '"></button>';
    }).join('') + '</div>' : '');
  }
  function qvDescHTML(d) {
    if (d.description == null) {
      return '<span class="hn-pdp-qv__sk"></span><span class="hn-pdp-qv__sk"></span><span class="hn-pdp-qv__sk is-short"></span>';
    }
    var R = reco();
    return R.description ? R.description(d.description) : '';   // testo già escapato dal motore
  }
  function qvRender() {
    var d = qvData(), cur = qvCur(d), h = d.h, cfg = QV.M.cfg;
    QV.card.innerHTML =
      '<div class="hn-pdp-qv__head" data-hn-qv-head><span class="hn-pdp-qv__grab" aria-hidden="true"></span>' +
        '<button type="button" class="hn-pdp-qv__x" data-hn-qv-close aria-label="Chiudi">' + QV_X + '</button></div>' +
      '<div class="hn-pdp-qv__body" data-hn-qv-body>' +
        '<div class="hn-pdp-qv__media">' + qvMediaHTML(d) + '</div>' +
        '<div class="hn-pdp-qv__info">' +
          '<h2 class="hn-pdp-qv__t" id="hn-pdp-qv-t">' + esc(h.short_title || h.title) + '</h2>' +
          (h.subtitle ? '<p class="hn-pdp-qv__sub">' + esc(h.subtitle) + '</p>' : '') +
          '<p class="hn-pdp-qv__price" data-hn-qv-price>' + qvPriceHTML(cur) + '</p>' +
          '<div class="hn-pdp-qv__opts" data-hn-qv-opts>' + qvOptsHTML(d, cur) + '</div>' +
          '<p class="hn-pdp-qv__has" data-hn-qv-has>' + esc(qvHas(cur)) + '</p>' +
          '<div class="hn-pdp-qv__desc" data-hn-qv-desc>' + qvDescHTML(d) + '</div>' +
          (cfg.qv_full ? '<a class="hn-pdp-qv__full" href="' + esc(productUrl(QV.p.handle)) + '" data-hn-qv-full>' + esc(cfg.qv_full) + '</a>' : '') +
        '</div></div>' +
      '<div class="hn-pdp-qv__foot"><button type="button" class="hn-pdp-qv__add" data-hn-qv-add></button></div>';
    qvSync(d, cur, false);
  }
  function qvSync(d, cur, scrollImg) {
    var c = QV.card, R = reco(), ok = !!(cur && cur.available);
    c.querySelector('[data-hn-qv-price]').innerHTML = qvPriceHTML(cur);
    c.querySelector('[data-hn-qv-opts]').innerHTML = qvOptsHTML(d, cur);
    c.querySelector('[data-hn-qv-has]').textContent = qvHas(cur);
    var b = c.querySelector('[data-hn-qv-add]');
    if (!b.classList.contains('is-busy')) { b.disabled = !ok; b.textContent = ok ? R.t('addToCart') : R.t('soldOut'); }
    if (scrollImg && cur && cur.image) {
      var k = -1, key = imgKey(cur.image);
      d.images.forEach(function (u, i) { if (k < 0 && imgKey(u) === key) k = i; });
      if (k >= 0) qvGo(k);
    }
  }
  function qvGo(k) {
    var st = QV.card.querySelector('[data-hn-qv-strip]'); if (!st) return;
    try { st.scrollTo({ left: k * st.clientWidth, behavior: 'smooth' }); } catch (e) { st.scrollLeft = k * st.clientWidth; }
    qvDots(k);
  }
  function qvDots(k) {
    QV.card.querySelectorAll('[data-hn-qv-dot]').forEach(function (x, i) { x.classList.toggle('is-on', i === k); });
  }
  function qvPick(k, val) {
    var d = qvData(), cur = qvCur(d), best = null, score = -1;
    d.vs.forEach(function (v) {
      if (!v.available || v.vals[k] !== val) return;
      var s = 0;
      v.vals.forEach(function (x, j) { if (j !== k && cur && cur.vals[j] === x) s++; });
      if (s > score) { best = v; score = s; }
    });
    if (!best) return;
    QV.sel = best.id;
    qvSync(d, best, true);
    // il gruppo dei bottoni è stato ridisegnato: il fuoco torna sulla scelta fatta
    var again = QV.card.querySelector('[data-hn-qv-opt="' + k + '"].is-on');
    if (again) try { again.focus({ preventScroll: true }); } catch (e) {}
  }
  function qvAdd(btn) {
    var d = qvData(), cur = qvCur(d), M = QV.M, p = QV.p, i = QV.i, R = reco();
    if (!cur || !cur.available || btn.disabled) return;
    M.touched = true;
    var meta = addMeta(M, p, i, cur.price);
    meta.hn_via = 'popup';
    btn.classList.add('is-busy');
    R.add(cur.id, 1, null, btn, function () {
      noteAdd(M.list.s, M.anchor.id, p.id, srcOf(p), i);
      // si chiude PRIMA che il motore apra il carrello: due blocchi dello
      // scroll uno sull'altro salverebbero la posizione sbagliata
      closeQV();
    }, meta);
    // un rifiuto (esaurito) rimette il bottone com'era: si toglie lo stato
    setTimeout(function () { if (QV.open && !btn.disabled) btn.classList.remove('is-busy'); }, 4000);
  }

  function qvKeys(e) {
    if (!QV.open) return;
    if (e.key === 'Escape') { e.preventDefault(); closeQV(); return; }
    if (e.key !== 'Tab') return;
    var f = [].slice.call(QV.card.querySelectorAll('button:not([disabled]),a[href]')).filter(function (x) {
      return x.offsetParent !== null && x.getAttribute('aria-disabled') !== 'true';
    });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (e.shiftKey && (a === first || a === QV.card)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  }
  function qvRoot() {
    if (QV.root) return QV.root;
    var r = document.createElement('div');
    r.className = 'hn-pdp-qv';
    r.setAttribute('data-hn-pdp-qv', '');
    r.innerHTML = '<div class="hn-pdp-qv__bg" data-hn-qv-close></div>' +
      '<div class="hn-pdp-qv__card" role="dialog" aria-modal="true" aria-labelledby="hn-pdp-qv-t" tabindex="-1"></div>';
    document.body.appendChild(r);
    QV.root = r; QV.card = r.querySelector('.hn-pdp-qv__card');
    r.addEventListener('click', function (e) {
      var t = e.target, x;
      if (!t || !t.closest) return;
      if (t.closest('[data-hn-qv-close]')) { e.preventDefault(); closeQV(); return; }
      if ((x = t.closest('[data-hn-qv-opt]'))) {
        if (x.getAttribute('aria-disabled') !== 'true') qvPick(parseInt(x.getAttribute('data-hn-qv-opt'), 10), x.getAttribute('data-hn-qv-val'));
        return;
      }
      if ((x = t.closest('[data-hn-qv-dot]'))) { qvGo(parseInt(x.getAttribute('data-hn-qv-dot'), 10)); return; }
      if ((x = t.closest('[data-hn-qv-add]'))) { qvAdd(x); return; }
      /* Alla scheda completa: la voce di cronologia dell'anteprima si toglie
         prima di andare, altrimenti tornando indietro ce ne sarebbe una in più. */
      if (t.closest('[data-hn-qv-full]') && QV.pushed && !(e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)) {
        try { history.replaceState(null, ''); } catch (err) {}
        QV.pushed = false;
      }
    });
    r.addEventListener('keydown', qvKeys);
    // i pallini seguono le foto (lo scroll non risale: lo si prende in cattura)
    r.addEventListener('scroll', function (e) {
      var st = e.target;
      if (!st || !st.hasAttribute || !st.hasAttribute('data-hn-qv-strip') || !st.clientWidth) return;
      qvDots(Math.round(st.scrollLeft / st.clientWidth));
    }, true);
    // telefono: si chiude trascinando giù la maniglia
    var y0 = null, dy = 0;
    r.addEventListener('touchstart', function (e) {
      if (!e.target.closest || !e.target.closest('[data-hn-qv-head]') || e.target.closest('[data-hn-qv-close]')) return;
      y0 = e.touches[0].clientY; dy = 0; QV.card.style.transition = 'none';
    }, { passive: true });
    r.addEventListener('touchmove', function (e) {
      if (y0 == null) return;
      dy = Math.max(0, e.touches[0].clientY - y0);
      QV.card.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: true });
    r.addEventListener('touchend', function () {
      if (y0 == null) return;
      y0 = null; QV.card.style.transition = ''; QV.card.style.transform = '';
      if (dy > 80) closeQV();
    });
    window.addEventListener('popstate', function () {
      if (QV.ignorePop) { QV.ignorePop = false; return; }
      if (QV.open) closeQV(true);
    });
    // pagina ripresa dalla cache del browser con l'anteprima aperta
    window.addEventListener('pageshow', function (e) { if (e.persisted && QV.open) closeQV(true); });
    return r;
  }
  function openQV(M, p, i, trigger) {
    var R = reco(), root = qvRoot();
    if (QV.open) closeQV();
    QV.M = M; QV.p = p; QV.i = i; QV.trigger = trigger || null; QV.full = null; QV.ignorePop = false;
    var act = (M.acts && M.acts[p.id]) || p.__act || null;
    QV.sel = act ? act.id : null;
    QV_VARS.forEach(function (k) { var v = M.el.style.getPropertyValue(k); if (v) root.style.setProperty(k, v); });
    qvRender();
    var token = QV.token = {};
    if (R.product) R.product(p.handle).then(function (full) {
      if (QV.token !== token || !QV.open || !full) return;
      QV.full = full;
      var body = QV.card.querySelector('[data-hn-qv-body]'), top = body ? body.scrollTop : 0;
      var dentro = QV.card.contains(document.activeElement);
      qvRender();
      var b2 = QV.card.querySelector('[data-hn-qv-body]'); if (b2) b2.scrollTop = top;
      if (dentro) try { QV.card.focus({ preventScroll: true }); } catch (e) {}
    });
    QV.open = true;
    /* ⚠️ La voce di cronologia PRIMA del blocco dello scroll: tornando indietro
       il browser rimette lo scroll registrato per la voce di partenza, e se a
       quel punto la pagina fosse già bloccata (scroll 0) la riporterebbe in cima.
       Difetto vero, preso da PD50. */
    try { history.pushState({ hnPdpQv: 1 }, ''); QV.pushed = true; } catch (e) { QV.pushed = false; }
    qvLock();
    root.classList.add('is-open');
    void root.offsetHeight;                       // parte dalla posizione chiusa, poi anima
    requestAnimationFrame(function () { if (QV.open) root.classList.add('is-in'); });
    try { QV.card.focus({ preventScroll: true }); } catch (e) {}
  }
  function closeQV(fromPop) {
    if (!QV.open) return;
    QV.open = false; QV.token = null;
    QV.root.classList.remove('is-in', 'is-open');
    QV.card.innerHTML = '';
    QV.card.style.transform = '';
    qvUnlock();
    if (!fromPop && QV.pushed && history.state && history.state.hnPdpQv) {
      QV.ignorePop = true;
      try { history.back(); } catch (e) { QV.ignorePop = false; }
    }
    QV.pushed = false;
    var t = QV.trigger; QV.trigger = null;
    if (t && t.focus && document.contains(t)) { try { t.focus({ preventScroll: true }); } catch (e) {} }
  }

  /* ================================ avvio ================================ */
  var MOUNTS = [];
  function setup(el) {
    var surface = el.getAttribute('data-hn-pdp');
    var M = { el: el, surface: surface, list: LISTS[surface], anchor: readJSON(el, 'data-hn-pdp-anchor'),
              cfg: readJSON(el, 'data-hn-pdp-cfg') || {}, acts: {} };
    if (!M.list || !M.anchor || !M.anchor.id) { show(M, false); return null; }
    M.variant = currentVariant(M.anchor);
    return M;
  }
  function renderAll(fresh) {
    MOUNTS.forEach(function (M) {
      if (M.holdout) return;
      if (!M.variant || anchorSoldOut(M.anchor, M.variant)) { show(M, false); return; }
      if (M.surface === 'cross') renderCross(M, fresh); else renderPack(M, fresh);
    });
  }
  function onVariantMaybe() {
    var changed = false;
    MOUNTS.forEach(function (M) {
      var v = currentVariant(M.anchor);
      if (v && (!M.variant || v.id !== M.variant.id)) { M.variant = v; changed = true; M.packVerified = false; }
    });
    if (changed) renderAll(true);
    else MOUNTS.forEach(function (M) {
      if (M.holdout) return;
      if (anchorSoldOut(M.anchor, M.variant)) { show(M, false); return; }
      /* ⚠️ Mai disegnato: all'avvio il pulsante sembrava esaurito (o non era ancora
         pronto) e renderAll è uscito prima di classificare. Senza questo ramo il
         blocco restava nascosto per sempre, anche dopo che il pulsante tornava
         normale — perché sotto si guardava solo se c'era qualcosa da RI-mostrare. */
      if (!M.shown && !M.plan) {
        if (M.surface === 'cross') renderCross(M, true); else renderPack(M, true);
        return;
      }
      if (M.el.style.display === 'none' && ((M.shown && M.shown.length) || (M.plan && M.plan.mode))) show(M, true);
    });
  }
  var pending = null;
  function later() { if (pending) clearTimeout(pending); pending = setTimeout(function () { pending = null; onVariantMaybe(); }, 60); }

  // aggiorna la riga scritta dallo snippet (?hnpdpdebug=1): lo script e' partito
  function debugBoot(msg) {
    if (!DEBUG) return;
    var ds = document.querySelectorAll('.hn-pdp__dbg0');
    for (var i = 0; i < ds.length; i++) ds[i].textContent = ds[i].textContent.replace(/script dei blocchi: .*$/, 'script dei blocchi: ' + msg);
  }
  function start() {
    var R = reco();
    var nodes = document.querySelectorAll('[data-hn-pdp]');
    debugBoot(R ? 'partito, motore del carrello presente' : 'partito, in attesa del motore del carrello');
    if (!nodes.length || !R) return false;
    var h = window.__hnPdpH ? 1 : 0, anchorId = null;
    for (var i = 0; i < nodes.length; i++) {
      var M = setup(nodes[i]); if (!M) continue;
      M.holdout = nodes[i].getAttribute('data-hn-pdp-h') === '1';
      anchorId = M.anchor.id;
      MOUNTS.push(M);
    }
    if (anchorId != null) { noteAnchor(anchorId, h); notePageView(anchorId); }
    renderAll(true);
    // variante: il tema non emette eventi, quindi si guardano il form e il bottone
    document.addEventListener('change', later, true);
    if (MOUNTS.length) {
      var b = atcButton(MOUNTS[0].anchor);
      if (b && window.MutationObserver) new MutationObserver(later).observe(b, { attributes: true, attributeFilter: ['disabled', 'class'] });
    }
    document.addEventListener('hn:cart:changed', function () {
      flush();
      MOUNTS.forEach(function (M) {
        if (M.holdout || !M.variant || anchorSoldOut(M.anchor, M.variant)) return;
        if (M.surface === 'cross') renderCross(M, false); else refreshPack(M);
      });
    });
    return true;
  }

  /* Il motore è caricato sincrono a fine body e questo file è `defer`, quindi
     di norma `HNCart.reco` c'è già. L'evento è la rete di sicurezza; senza motore
     (carrello spento dal Personalizza tema) i blocchi non si mostrano affatto,
     invece di lasciare uno scheletro vuoto sotto il bottone. */
  if (!start()) {
    var gone = false;
    document.addEventListener('hn:cart:ready', function () { if (!gone) { gone = true; start(); } });
    setTimeout(function () {
      if (gone) return;
      gone = true;
      if (!start()) {
        debugBoot('motore del carrello ASSENTE dopo 4 s: blocchi nascosti');
        var ns = document.querySelectorAll('[data-hn-pdp]');
        for (var i = 0; i < ns.length; i++) ns[i].style.display = 'none';
      }
    }, 4000);
  }
  /* Per la diagnostica e per la suite (tools/run-pdp-tests.mjs): le funzioni
     pure si provano direttamente, invece di dedurle dal DOM. */
  window.HNPdp = { mounts: MOUNTS, attr: function () { return attrValue(loadLog()); }, log: loadLog,
                   _t: { chooseVariant: chooseVariant, variantLabel: variantLabel, planPack: planPack,
                         openQV: openQV, closeQV: closeQV, qv: QV } };
})();
